import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';

export default function DashboardWidgets({tempDetails,currentDate}) {
  return (
    <Box sx={{ flexGrow: 1, marginBottom: 5 }}>
      <Grid container spacing={4}>
        <Grid size={{ md: 6, xs: 12 }} className="weather_image">
        <Box className='weather_section'>
        <h1 className="dash_temp"><WbSunnyOutlinedIcon fontSize="large"/> {" "}{tempDetails?.temp} {" "}<sup>C</sup> 
        <span className="dash_location">{tempDetails?.location}</span></h1>
        <h6   className="date_button">{currentDate}</h6>
        </Box>
        </Grid>
        <Grid size={{ md: 6, xs: 12 }}>
          <Grid container spacing={3}>
            <Grid size={{ md: 6, xs: 6 }} className="dashbaord_card_one">
              <Typography gutterBottom variant="h6" component="div" className="dashboard_cardText">
                Today's Appointments
              </Typography>
              <Typography variant="h4" className="dashboard_cardValue">
                {tempDetails?.today_appointments}
              </Typography>
            </Grid>
            <Grid size={{ md: 6, xs: 6 }} className="dashbaord_card_two" >
              <Typography gutterBottom variant="h6" component="div" className="dashboard_cardText">
                Active Patients
              </Typography>
              <Typography variant="h4" className="dashboard_cardValue">
                {tempDetails?.active_patients}
              </Typography>
            </Grid>
            <Grid size={{ md: 6, xs: 6 }} className="dashbaord_card_three">
              <Typography gutterBottom variant="h6" component="div" className="dashboard_cardText">
                  New Patients
              </Typography>
              <Typography variant="h4" className="dashboard_cardValue">
                {tempDetails?.new_patients}
              </Typography>
            </Grid>
            <Grid size={{ md: 6, xs: 6 }} className="dashbaord_card_four">
              <Typography gutterBottom variant="h6" component="div" className="dashboard_cardText">
                Total Patients
              </Typography>
              <Typography variant="h4" className="dashboard_cardValue">
                {tempDetails?.total_patients}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
